import doFetchGitHubIssues from './doFetchGitHubIssues'
import selectCurrentTicketLinkedIssueIds from '../selectors/selectCurrentTicketLinkedIssueIds'

export default function doFetchCurrentTicketLinkedIssues() {
  return (dispatch, getState) => {
    const issueIds = selectCurrentTicketLinkedIssueIds(getState())
    doFetchGitHubIssues(issueIds)
  }
}
